export class Screen {
  static maxWidth: string = '1320px';
  static minWidth: string = '280px';
  static xs: string = '576px';
  static sm: string = '768px';
  static md: string = '992px';
  static lg: string = '1200px';
  static xl: string = '1400px';
}

export class Radius {
  static s0 = 0;
  static s5 = 5;
  static s8 = 8;
  static s10 = 10;
  static s16 = 16;
  static s24 = 24;
}

export class Sizes {
  static s0 = '0px';
  static s5 = '5px';
  static s8 = '8px';
  static s10 = '10px';
  static s12 = '12px';
  static s14 = '14px';
  static s16 = '16px';
  static s18 = '18px';
  static s20 = '20px';
  static s24 = '24px';
  static s32 = '32px';
  static s36 = '36px';
  static s48 = '48px';
  static s60 = '60px';
  static s80 = '80px';
  static s100 = '100px';
  static s120 = '120px';
  static s150 = '150px';
  static s180 = '180px';
  static s240 = '240px';
  static s260 = '260px';
}
